export default "__VITE_ASSET__DAteCGS8__"